import { motion } from "framer-motion";
import { Store, Building2, Warehouse, Handshake, Target, Briefcase } from "lucide-react";

const SERVICES = [
  {
    icon: Store,
    title: "Imóveis Comerciais",
    desc: "Lojas, pontos comerciais, salas e espaços voltados para operação de negócios que precisam de visibilidade, localização e estrutura.",
    img: "https://images.pexels.com/photos/14526255/pexels-photo-14526255.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-4",
  },
  {
    icon: Building2,
    title: "Imóveis Corporativos",
    desc: "Salas executivas, conjuntos empresariais e espaços ideais para empresas que buscam posicionamento, conforto e funcionalidade.",
    img: "https://images.unsplash.com/photo-1759092912803-f2332d1f8d93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc3NjczNjMwNHww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-4",
  },
  {
    icon: Warehouse,
    title: "Industriais & Logísticos",
    desc: "Galpões, centros de distribuição, armazéns e áreas operacionais para empresas que precisam de espaço, acesso e eficiência logística.",
    img: "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwd2FyZWhvdXNlfGVufDB8fHx8MTc3NjczNjMwNHww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-4",
  },
  {
    icon: Handshake,
    title: "Intermediação Estratégica",
    desc: "Acompanhamos toda a jornada da negociação, aproximando proprietário e locatário com mais assertividade e clareza.",
    span: "lg:col-span-4",
    noImg: true,
  },
  {
    icon: Target,
    title: "Captação de Imóveis",
    desc: "Trabalhamos na apresentação e posicionamento do imóvel para aumentar sua atratividade no mercado e acelerar oportunidades reais.",
    span: "lg:col-span-4",
    noImg: true,
  },
  {
    icon: Briefcase,
    title: "Consultoria Comercial",
    desc: "Analisamos perfil, necessidade e viabilidade para que a locação aconteça de forma mais segura e alinhada ao objetivo do negócio.",
    span: "lg:col-span-4",
    noImg: true,
  },
];

export const Services = () => {
  return (
    <section
      id="servicos"
      className="relative py-24 md:py-32 lg:py-40 bg-[#08122A]"
      data-testid="services-section"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="max-w-3xl mb-16 md:mb-24"
        >
          <div className="flex items-center gap-4 mb-6">
            <div className="gold-divider" />
            <span className="eyebrow">O que fazemos</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#F5F1EA]" data-testid="services-title">
            Soluções em <span className="italic gold-text">locação</span> não residencial
          </h2>
        </motion.div>

        {/* Bento grid */}
        <div className="grid lg:grid-cols-12 gap-6 md:gap-8">
          {SERVICES.map((svc, i) => {
            const Icon = svc.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.2, 0.8, 0.2, 1] }}
                className={`service-card ${svc.span} bg-[#0E1E45]/60 border border-[#D4B366]/20 p-0 flex flex-col`}
                data-testid={`service-card-${i}`}
              >
                {!svc.noImg && svc.img && (
                  <div className="overflow-hidden h-56 md:h-64">
                    <img src={svc.img} alt={svc.title} className="card-img w-full h-full object-cover" />
                  </div>
                )}
                <div className="p-8 md:p-10 flex flex-col flex-1">
                  <div className="mb-6">
                    <div className="w-11 h-11 flex items-center justify-center border border-[#D4B366]/40 text-[#E8C97A]">
                      <Icon size={20} strokeWidth={1.3} />
                    </div>
                  </div>
                  <h3 className="font-display text-2xl md:text-[1.7rem] text-[#F5F1EA] mb-4 leading-tight">
                    {svc.title}
                  </h3>
                  <p className="text-[#A2AAC2] text-sm md:text-[0.92rem] leading-[1.8] font-light">
                    {svc.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
